export const DELETE_CLIP_REQUEST_OPEN_MODAL = "DELETE_CLIP_REQUEST_OPEN_MODAL";
export const DELETE_CLIP_REQUEST_REQUEST = "DELETE_CLIP_REQUEST_REQUEST";
export const DELETE_CLIP_REQUEST_RESULT = "DELETE_CLIP_REQUEST_RESULT";